"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useWorkspaceStore } from "@/stores/useWorkspaceStore";
import { Button } from "@/components/ui/button";
interface SetupGateProps {
  children: React.ReactNode;
}

/**
 * Gate used in the dashboard layout: fetches workspaces on mount.
 * If the user has no workspaces (owned or invited), redirects to /setup.
 * If fetch fails, shows error state with retry (does not redirect).
 * Otherwise renders children (dashboard content).
 */
export function SetupGate(t0) {
  const $ = _c(21);
  const {
    children
  } = t0;
  const router = useRouter();
  const {
    workspaces,
    loading,
    error,
    isWorkspacesInitialized,
    fetchWorkspaces,
    clearError
  } = useWorkspaceStore();
  let t1;
  let t2;
  if ($[0] !== fetchWorkspaces) {
    t1 = () => {
      fetchWorkspaces();
    };
    t2 = [fetchWorkspaces];
    $[0] = fetchWorkspaces;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== isWorkspacesInitialized || $[4] !== loading || $[5] !== router || $[6] !== workspaces.length) {
    t3 = () => {
      if (loading || !isWorkspacesInitialized) {
        return;
      }
      if (workspaces.length === 0) {
        router.replace("/setup");
      }
    };
    t4 = [loading, isWorkspacesInitialized, workspaces.length, router];
    $[3] = isWorkspacesInitialized;
    $[4] = loading;
    $[5] = router;
    $[6] = workspaces.length;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  if (error) {
    let t5;
    if ($[9] !== error) {
      t5 = <p className="text-sm text-destructive">{error}</p>;
      $[9] = error;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== clearError || $[12] !== fetchWorkspaces) {
      t6 = <Button variant="outline" onClick={() => {
        clearError();
        fetchWorkspaces();
      }}>Retry</Button>;
      $[11] = clearError;
      $[12] = fetchWorkspaces;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    let t7;
    if ($[14] !== t5 || $[15] !== t6) {
      t7 = <div className="flex h-screen w-full flex-col items-center justify-center gap-4 p-4">{t5}{t6}</div>;
      $[14] = t5;
      $[15] = t6;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    return t7;
  }
  if (!isWorkspacesInitialized || loading) {
    let t5;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="flex h-screen w-full items-center justify-center"><div className="text-center"><h2 className="text-lg font-semibold">Loading...</h2><p className="text-sm text-muted-foreground">Checking your workspaces…</p></div></div>;
      $[17] = t5;
    } else {
      t5 = $[17];
    }
    return t5;
  }
  if (workspaces.length === 0) {
    let t5;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="flex h-screen w-full items-center justify-center"><div className="text-center text-muted-foreground">Redirecting to setup…</div></div>;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    return t5;
  }
  let t5;
  if ($[19] !== children) {
    t5 = <>{children}</>;
    $[19] = children;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
}